import { Activity, BodyProps } from "@ofqual/portal-activity-feed";
import { fieldLabels } from "../sections/fieldLabels";
import { Recipient } from "../../domain/Recipient";

export enum DialogType {
  ActivityAction,
  AddNote,
  AddInternalMessage,
  AddEvent,
  CompleteEvent,
  CompleteEventApprove,
  CompleteEventReject,
  SendPublicMessage,
}

export interface EntityDialog {
  dialogType: DialogType;
  focusedActivity?: Activity;
}

export type ActivityDocument = {
  blobId: string;
  fileName: string;
  contentType: string;
};

export type EventActivityBody = {
  referenceId: string;
  foiEventType: number;
  meetingDate: string;
  note: string;
  recipients: Recipient[];
  documents: ActivityDocument[];
};

export type NoteAttachmentActivityBody = {
  message: string;
  documents: ActivityDocument[];
};

export type NoteAttachmentBodyProps = {
  bodyProps: BodyProps<NoteAttachmentActivityBody>;
};

export type EventAttachmentActivityBody = {
  documents: ActivityDocument[];
};

export type EventAttachmentBodyProps = {
  bodyProps: BodyProps<EventAttachmentActivityBody>;
};

export type ClosedActivityBody = {
  sharedWithIfate?: boolean;
};

export type ActivityBody = {
  id: string;
  changes: FieldChange[];
};

export type CaseAttachmentActivityBody = {
  subject: string;
  message: string;
  documents: ActivityDocument[];
};

export type CaseEventAttachmentActivityBody = {
  responseType: number;
  foiEventType: number;
  meetingDate: string;
  note: string;
  recipients: Recipient[];
  documents: ActivityDocument[];
};

export interface ActivityBodyProps extends ActivityBody {
  documents: {
    blobId: string;
    fileName: string;
    contentType: string;
  }[];
}

export interface EventActivityBodyProps {
  id: number;
  foiEventType: number;
  message: string;
  meetingDate: string;
  recipients: Recipient[];
  documents: ActivityDocument[];
  action?: string;
}

export type EventCompleteActivityBodyProps = {
  id: string;
  foiEventType: number;
  note: string;
  documents: ActivityDocument[];
  action: string;
  referenceId: string;
  meetingDate: string;
};

export type FieldChange = {
  field: keyof typeof fieldLabels;
  oldValue: string | null;
  newValue: string | null;
};

export type InternalMessage = {
  subject: string;
  message: string;
  upns: Array<string>;
  documents: ActivityDocument[];
};

export type ShareBody = {
  whitelist: string[];
};

export type RecordTransfer = {
  action: string;
  upn: string;
  name: boolean;
};
